import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MessageService } from '@openng/optimus-ui/api';
import { ToastModule } from '@openng/optimus-ui/toast';
import { ButtonModule } from '@openng/optimus-ui/button';
import { RippleModule } from '@openng/optimus-ui/ripple';
import { ToastBarService } from '../services/toast-bar.service';
import { ToastMessageOptions } from '@openng/optimus-ui/api';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-toast-bar',
    imports: [ToastModule, ButtonModule, RippleModule],
    templateUrl: './toast-bar.component.html',
    styleUrl: './toast-bar.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [MessageService]
})
export class ToastBarComponent implements OnInit, OnDestroy {
  private _destroy$ = new Subject<void>();

  constructor(
    private messageService: MessageService,
    private toastBarService: ToastBarService
  ) {}

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  ngOnInit(): void {
    // Subscribe to the toast message stream
    this.toastBarService.toastMessage$
      .pipe(takeUntil(this._destroy$))
      .subscribe((msg: ToastMessageOptions) => {
        this.customToast(msg);
      });
  }

  customToast(message: ToastMessageOptions) {
    this.messageService.add({
      severity: message.severity,
      summary: message.summary,
      detail: message.detail,
      closable: false,
      life: 3000,
    });
  }
  showSuccess() {
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: 'Message Content',
      closable: false,
      life: 3000,
    });
  }

  showInfo() {
    this.messageService.add({
      severity: 'info',
      summary: 'Info',
      detail: 'Message Content',
    });
  }

  showWarn() {
    this.messageService.add({
      severity: 'warn',
      summary: 'Warn',
      detail: 'Message Content',
    });
  }

  showError() {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Message Content',
    });
  }

  showContrast() {
    this.messageService.add({
      severity: 'contrast',
      summary: 'Error',
      detail: 'Message Content',
    });
  }

  showSecondary() {
    this.messageService.add({
      severity: 'secondary',
      summary: 'Secondary',
      detail: 'Message Content',
    });
  }
}
